import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CreateTask from '../../components/modal/CreateTask';
import CreateTaskLegacy from '../../components/modal/CreateTaskLegacy';
import { triggerTaskCreation, triggerAutoUploadAndTaskCreation } from '../../actions/records';
import { getEmaTaskProviders, getKareoTaskProviders, getTaskTemplatesByQuery } from '../../actions/userProfile';
import { hasFeatureInLocalStorage, CREATE_TASK_CHART_CLARITY_FEATURE } from '../../global/featureFlags';

class CreateTaskDialog extends Component {
  static propTypes = {
    editReceivedRecordLabels: PropTypes.func.isRequired,
  }

  render() {
    // Gate the redesigned modal behind the flag; orgs without it keep the
    // original modal verbatim. Deletion owner/date: EMR Upload Experience,
    // July 31, 2026, once create_task_chart_clarity rolls out to all orgs.
    const Modal = hasFeatureInLocalStorage(CREATE_TASK_CHART_CLARITY_FEATURE)
      ? CreateTask
      : CreateTaskLegacy;
    return (
      <div>
        <Modal
          {...this.props}
        />
      </div>
    );
  }
}

CreateTaskDialog.propTypes = {
  triggerTaskCreation: PropTypes.func.isRequired,
};


export default connect(state => ({
  sendToken: state.auth.data.sendToken,
  allEmaTaskProviders: state.userProfile.allEmaTaskProviders,
  allKareoTaskProviders: state.userProfile.allKareoTaskProviders,
}), { triggerTaskCreation, triggerAutoUploadAndTaskCreation, getEmaTaskProviders, getKareoTaskProviders, getTaskTemplatesByQuery })(CreateTaskDialog);
